import { IContact } from '@app/models/Contact'
import * as React from 'react'
import Image from './Image'
import { getDefaultImageUrl, getContactImage, getImageSize } from '@app/utils/profileImage'

interface IContactProfileImageProps {
  contact: string | IContact
  size: number
}

export default class ContactProfileImage extends React.PureComponent<
  IContactProfileImageProps
> {
  public render() {
    if (!this.props.contact) {
      return (
        <img
          className='img-circle'
          height={this.props.size}
          src={getDefaultImageUrl(false, this.props.size)}
          width={this.props.size}
        />
      )
    } else if (typeof this.props.contact === 'string') {
      return (
        <img
          className='img-circle'
          height={this.props.size}
          src={getContactImage(this.props.contact, this.props.size)}
          width={this.props.size}
        />
      )
    } else {
      const contact = this.props.contact as IContact
      return (
        <Image
          className='img-circle'
          defaultImageUrl={getDefaultImageUrl(
            contact.isCompany,
            this.props.size,
          )}
          height={this.props.size}
          image={contact.profileImage}
          size={getImageSize(this.props.size)}
          width={this.props.size}
        />
      )
    }
  }
}
